<div class="filter">
  <riv-checkbox
    [identifier]="id"
    [value]="selected | async"
    (valueChange)="changeSelected($event)"
  >
    <span class="label">
      <span>{{ label }}</span>
      <span *ngIf="count != null">{{ count }}</span>
    </span>
  </riv-checkbox>
</div>
